import { createFileRoute } from '@tanstack/react-router'
import { CASE_SETTINGS_TABS, CaseSettingsPage } from '@bloo-team/product-vantage'
import type { CaseSettingsSearch, CaseSettingsTab } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0): Settings · Vantage · Cases — the case-management
 * tenant settings (@bloo-team/product-vantage) inside the Settings frame;
 * `?tab=` picks the screen (docs/cases.md §Settings).
 */
function CaseSettingsRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const search = Route.useSearch()
  return <CaseSettingsPage clusterId={clusterId} scopeId={scopeId} search={search} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/vantage/cases')({
  validateSearch: (search: Record<string, unknown>): CaseSettingsSearch =>
    CASE_SETTINGS_TABS.includes(search.tab as CaseSettingsTab) ? { tab: search.tab as CaseSettingsTab } : {},
  component: CaseSettingsRoute,
})
